module.exports = __webpack_public_path__ + "static/img/improvement_4.23ae0ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/improvement_4.png
// module id = 60vL
// module chunks = 1